import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, GraduationCap, School, Utensils, FlaskConical, Building2, BedDouble, Pill, Stethoscope } from "lucide-react";
import { INDUSTRIES } from "@/data/industries";
import Reveal from "@/components/Reveal";

const ICONS = {
  "graduation-cap": GraduationCap,
  school: School,
  utensils: Utensils,
  "flask-conical": FlaskConical,
  "building-2": Building2,
  "bed-double": BedDouble,
  pill: Pill,
  stethoscope: Stethoscope,
};

const Industries = () => {
  return (
    <>
      <section className="pt-[160px] pb-20 max-w-editorial mx-auto px-6 md:px-10 lg:px-12">
        <div className="font-mono text-[11px] tracking-overline uppercase text-accent mb-6">
          [ Industries we serve ]
        </div>
        <h1 className="font-display font-bold text-[3rem] md:text-[5rem] leading-[0.98] tracking-tightest max-w-4xl">
          Sector-aware engineers,{" "}
          <span className="text-brand">compliance-first delivery.</span>
        </h1>
        <p className="mt-8 text-[18px] text-muted-foreground max-w-2xl leading-relaxed">
          We work in environments where downtime hurts and compliance is non-negotiable —
          from term-time university campuses and live restaurant kitchens to clean-room
          laboratories and customer-facing banking halls.
        </p>
      </section>

      <section className="pb-24 max-w-editorial mx-auto px-6 md:px-10 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-2">
          {INDUSTRIES.map((ind, i) => {
            const Icon = ICONS[ind.icon] || Building2;
            return (
              <Reveal key={ind.name} delay={i * 50} className="border-t border-black/8 py-8">
                <Icon className="h-6 w-6 text-brand mb-5" strokeWidth={1.6} />
                <h3 className="font-display font-semibold text-[1.2rem] tracking-tight mb-2">{ind.name}</h3>
                <p className="text-[13px] text-muted-foreground leading-relaxed">{ind.note}</p>
              </Reveal>
            );
          })}
        </div>
      </section>

      <section className="py-24 bg-paper-warm">
        <div className="max-w-editorial mx-auto px-6 md:px-10 lg:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-7">
              <div className="font-mono text-[11px] tracking-overline uppercase text-muted mb-4">[ Featured ]</div>
              <h2 className="font-display font-bold text-[2rem] md:text-[3rem] tracking-tightest leading-[1.05] mb-6">
                560 fire dampers, three campuses, zero academic disruption.
              </h2>
              <p className="text-[16px] text-muted-foreground max-w-xl leading-relaxed mb-8">
                A glimpse into how we deliver in the most demanding live environments —
                with Smartsheet dashboards, tight comms and engineers who know how to work around occupants.
              </p>
              <Link to="/case-studies" data-testid="industries-case-cta" className="inline-flex items-center gap-2 group">
                <span className="font-semibold border-b border-ink/30 pb-1 group-hover:border-ink transition-colors">
                  University of Reading case study
                </span>
                <ArrowUpRight className="h-4 w-4" />
              </Link>
            </div>
            <div className="lg:col-span-5">
              <img
                src="/hero/engineer-onsite.jpg"
                alt="Engineer at site"
                className="w-full aspect-[4/3] object-cover rounded-md"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Industries;
